import type { SvpCategoryId } from '@vgtv/api-client/lib/svp_category';

export const participantsBySeriesId = {
  100441: [
    {
      name: 'Erik Follestad',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/fc64c8b3ecfc5edd6abdf92dc782d61d.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/f861639a63cd4c3977bff79b745413cf.jpg',
      },
    },
    {
      name: 'Janne Rønningen',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/dce6b8d7bf36c5ddd5eeb71eeef36bbf.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/0b4bdc7adeedbf8b68df3367e8f4327f.jpg',
      },
    },
    {
      name: 'Hans Magne Skard',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/7cfd3ca99ab339cda8b279809294f531.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/763408ba9b0eead2bf4051e565cc3e87.jpg',
      },
    },
    {
      name: 'Steinar Klouman Hallert',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/be497db6c89e836e151b4a275c2784f0.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/e942a9a3fb37ca40a3c84dd26a8c33de.jpg',
      },
    },
    {
      name: 'Nora Svenningsen',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/82ee04d01c57ef1973f20d46161be3e9.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/9eeadb688a7e27ad4189dbbdcc2c40ab.jpg',
      },
    },
    {
      name: 'Javad El Bakali',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/d4f742afe190768a923dcdd719d62469.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/ebc86575133e31487ae899e2a2a31fa8.jpg',
      },
    },
    {
      name: 'Bård Ylvisåker',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/ab8a9f66e92c1b52ae925b2c416fc296.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/cb47334c667ad1fa40d610f1409033a3.jpg',
      },
    },
    {
      name: 'Veslemøy Mørkrid',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/92efd712e759cbba6699ad6defb34c49.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/e1edcb13313d5a2c4b2dd52f24358523.jpg',
      },
    },
    {
      name: 'Jon Martin Henriksen',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/6807e5dcb0d72cd9064292392aac8986.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/0581e546b5661f17b07e53f1fb3ac732.jpg',
      },
    },
    {
      name: 'Martin Lepperød',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/aeec24b9604439faac6ad156e7407308.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/fa14d67e390e02d6b3787ddf476815d6.jpg',
      },
    },
    {
      name: 'Maria Stavang',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/2aa86c06b85d12b0cd755ce06a10a3a4.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/94ed3048b2ab579feb074ed16bee2a42.jpg',
      },
    },
    {
      name: 'Gaute Berg Næss',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/135434dbfdc08635f77b3b724912289f.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/35c452947878a1b8910f8a649a79589e.jpg',
      },
    },
  ],
  100528: [
    {
      name: 'Fetisha Williams',
      description:
        'Fetisha Williams er med i Kjøret Gård på VGTV. Fetisha er med på første sesong av Martha Leivestad sin nye serie, Kjøret Gård. Hun er 30 år, og er født i USA. I dag jobber hun som influenser, podcast-programleder og mediepersonlighet. Fetisha har vært med i «71° nord – Norges tøffeste kjendis» og VGTVs program «Skål, Martha!». Williams har hatt flere podcaster, blant annet med Sophie Elise Isachsen i NRK. Da Fetisha i juni 2023 overtok podcasten alene ble fikk den navnet «Fetisha +1», og er en av Norges mest populære podkaster.',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/f837287f35f3edaf139f0c342a7415ea.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/7954e653af99b9f41425c0562e1f22ce.jpg',
      },
    },
    {
      name: 'Camilla Lorentzen',
      description:
        'Camilla Lorentzen er med i Kjøret Gård på VGTV. Camilla er med på første sesong av Martha Leivestad sin nye serie, Kjøret Gård. Hun er 34 år og bor i Oslo i Norge. Hun er influenser, personlig trener og mediepersonlighet, og driver sosiale medier-kontoer sammen med kona Julie Lorenzen (tidligere Julie Visnes), som hun venter barn sammen med. De har kjøpt et stort hus sammen i Tønsberg, som de pusser opp. Camilla er kjent for å være kroppspositivist og LGBTQ+-forkjemper.',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/7bea2c9c049b0af2411475edce4ad94f.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/91be792ec00ea9220dfd7533f9c6c0fe.jpg',
      },
    },
    {
      name: 'Martin Lepperød',
      description:
        'Martin Axel Henny Lepperød er med på Kjøret Gård på VGTV. Martin er med i sesong 1 av Martha Leivestad sin nye serie, Kjøret Gård. Martin Axel Henny Lepperød er en norsk programleder, skuespiller og standupkomiker fra Nesodden. Lepperød er for mange kjent fra NRKs P3-morgen.',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/52318c110023825b44e7d9dc95ad89c2.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/f2dd7d2212beb10d86e55d2e68770ad8.jpg',
      },
    },
    {
      name: 'Emil Gukild',
      description:
        'Emil Gukild er med i Kjøret Gård på VGTV. Emil er med på første sesong av Martha Leivestad sin nye serie, Kjøret Gård.  Han er 31 år og er født i USA. Nå jobber han som journalist og programleder. Emil er mest kjent for ha å jobbet med sport i NRK og TV Norge. Han har også vært med i «Søvnløs» på VGTV, sammen med kona Linnea Myhre.',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/7cdbe5680f1a54863d7ba50d0af764f4.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/24de8398b8b48a0cb70d3a0c618bda08.jpg',
      },
    },
    {
      name: 'Safari Yves Shabani',
      description:
        'Safari Yves Shabani er med i Kjøret Gård på VGTV. Safari er med på første sesong av Martha Leivestad sin nye serie, Kjøret Gård. Han er 26 år, er vokst opp i Zambia, og jobber som TV-profil. Safari er kjent fra Youtube-serien «Safari på safari», og har vært deltager i «71 grader nord - team».',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/078d4fa5754456f365b8cede513e9abd.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/8268048c3457b97007bca28d48fe507e.jpg',
      },
    },
    {
      name: 'Caroline Johansen',
      description:
        'Caroline Johansen er med på Kjøret Gård på VGTV. Caroline er med i sesong 1 av Martha Leivestad sin nye serie, Kjøret Gård. Caroline Johansen er en norsk skuespiller, manusforfatter og regissør. Hun er kjent fra roller som Jernia-ekspeditøren Ellen i Side om side, og Karita i Nissene i bingen. Som regissør har hun vært ansvarlig for 15 episoder i den første sesongen av Hvite gutter.',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/fb0898e59e9e521bfc06745c599d2a0c.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/b7397241e2530337f4c8a60d82e91ae4.jpg',
      },
    },
    {
      name: 'Amir Asgharnejad',
      description:
        'Amir Asgharnejad er med i Kjøret Gård på VGTV. Amir er med på første sesong av Martha Leivestad sin nye serie, Kjøret Gård. Han er født i Iran og oppvokst i Kristiansand. Amir Asgharnejad er skuespiller og komiker. Han har vært med i «Unge Lovende», «Hvite gutter» og «Kongen befaler». Han ble nominert til Humorprisen 2020/2021 til publikumsprisen året morsomste på TV.',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/99b4f40b3d2b1d8e9f4e6163e46c2f78.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/a41f8c3308631faae4d5f4138d0129e7.jpg',
      },
    },
    {
      name: 'Ronja Vestlund Bysveen',
      description:
        'Ronja Vestlund Bysveen er med på Kjøret Gård på VGTV. Ronja er med i sesong 1 av Martha Leivestad sin nye serie, Kjøret Gård. Ronja er kjent fra TikTok. Hun gikk først viralt på TikTok i 2020.',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/38d348978138f37a18148245cae2e631.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/d8251d5bbd38ee0af9aa8e9c8a82ba1e.jpg',
      },
    },
    {
      name: 'Egil Andreas Skurdal',
      description:
        'Egil Andreas Skurdal er med på Kjøret Gård på VGTV. Egil er med i sesong 1 av Martha Leivestad sin nye serie, Kjøret Gård. Egil Andreas Skurdal er sanger og pianist.',
      images: {
        thumbnail:
          'https://images.stream.schibsted.media/users/vgtv/images/04cf8b74d987579c23eeb05b26e31895.jpg',
        card: 'https://images.stream.schibsted.media/users/vgtv/images/1d4ff21174a30ada4fcc79dc48af4a17.jpg',
      },
    },
  ],
} as Record<
  SvpCategoryId,
  {
    name: string;
    description: string;
    images: {
      thumbnail: string;
      card: string;
    };
  }[]
>;
